/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IClasificaciones from './entidades/clasificaciones';
import IFiltrosClasificaciones from './entidades/filtrosClasificaciones';

export default class ModeloClasificaciones {
    public consultarClasificaciones() {
        return manejadorRest<IRespuesta<IClasificaciones>>(() =>
            negocio.get('Clasificacion/ConsultarListaClasificacion')
        );
    }
    public crearClasificaciones(clasificaciones: IClasificaciones) {
        return manejadorRest<IRespuesta<IClasificaciones>>(() =>
            negocio.post('Clasificacion/GuardarClasificacion', clasificaciones)
        );
    }
    public editarClasificaciones(clasificaciones: IClasificaciones) {
        return manejadorRest<IRespuesta<IClasificaciones>>(() =>
            negocio.put('Clasificacion/EditarClasificacion', clasificaciones)
        );
    }
    public eliminarClasificaciones(clasificaciones: IClasificaciones) {
        return manejadorRest<IRespuesta<IClasificaciones>>(() =>
            negocio.delete('Clasificacion/EliminarClasificacion', clasificaciones)
        );
    }
    public consultarListaClasificacionesPorFiltro(filtrosClasificaciones: IFiltrosClasificaciones) {
        return manejadorRest<IRespuesta<IClasificaciones>>(
            () => negocio.post('Clasificacion/ConsultarListaClasificacionPorFiltro', filtrosClasificaciones),
            true
        );
    }
}
